module.exports = __webpack_public_path__ + "7835aa7355d627e8224031f8845db755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/workspace_placeholder.svg
// module id = 3588
// module chunks = 1